module.exports = "./img/326e25370830e0466dea550e3a7f29d9.png";